export const advertisementData = {
  talk1: {
    type: "advertisement",
    title: "New Product Advertisement",
    versions: {
      basic: {
        script: `Our goal at GreenTech Solar Incorporated is to deliver sustainable energy solutions for homes and businesses. <mark>Our solar panels are made of high‑efficiency monocrystalline silicon materials</mark>. <mark>Beginning June 1, homeowners can schedule a free consultation on our website</mark>. For installation inquiries or to request a quote, <mark>please contact your local GreenTech dealer today</mark>.`,
        translation: `저희 GreenTech Solar 주식회사의 사명은 가정과 기업에 지속 가능한 에너지 솔루션을 제공하는 것입니다. 저희 태양광 패널은 고효율 단결정 실리콘 재료로 제작되었습니다. 6월 1일부터 주택 소유자는 웹사이트에서 무료 상담을 예약하실 수 있습니다. 설치 문의 또는 견적 요청은 가까운 GreenTech 대리점에 연락해 주십시오.`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us1.mp3",
          uk: "audios/part4/advertisement/uk/uk1.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question:
          'Why does the speaker say "<mark>made of high‑efficiency monocrystalline silicon materials</mark>"?',
        options: {
          A: "To <mark>highlight</mark> product performance",
          B: "To <mark>recognize</mark> manufacturing partners",
          C: "To explain a <mark>testing procedure</mark>",
          D: "To clarify <mark>warranty terms</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 제품 성능을 강조하기 위해
B: 제조 파트너를 인정하기 위해
C: 시험 절차를 설명하기 위해
D: 보증 조건을 명확히 하기 위해

정답 A: 스크립트에서 "Our solar panels are made of high‑efficiency monocrystalline silicon materials"라고 언급함으로써 제품의 성능을 강조하고 있습니다.`,
      },
      {
        id: 2,
        question: "What can homeowners do starting <mark>June 1</mark>?",
        options: {
          A: "Apply for a <mark>government rebate</mark>",
          B: "Schedule <mark>a free consultation</mark>",
          C: "Purchase <mark>replacement parts</mark>",
          D: "Attend a <mark>local seminar</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 정부 보조금을 신청할 수 있다
B: 무료 상담을 예약할 수 있다
C: 교체 부품을 구매할 수 있다
D: 지역 세미나에 참석할 수 있다

정답 B: 스크립트의 "Beginning June 1, homeowners can schedule a free consultation on our website"에서 6월 1일부터 주택 소유자가 무료 상담을 예약할 수 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "Who should you contact to request an <mark>installation quote</mark>?",
        options: {
          A: "The GreenTech <mark>website</mark>",
          B: "A government <mark>office</mark>",
          C: "Your local <mark>dealer</mark>",
          D: "The customer service <mark>hotline</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: GreenTech 웹사이트
B: 관공서
C: 가까운 대리점
D: 고객 서비스 센터

정답 C: 스크립트의 "please contact your local GreenTech dealer today"에서 설치 견적을 요청하려면 가까운 대리점에 연락해야 한다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk2: {
    type: "advertisement",
    title: "Eco-Friendly Product Advertisement",
    versions: {
      basic: {
        script: `At EcoLiving Innovations, we believe sustainability starts with small changes in everyday life. That's why we are excited to introduce the <mark>BambooPure Toothbrush</mark>—a <mark>natural and biodegradable</mark> alternative to plastic toothbrushes.
        Unlike conventional toothbrushes, <mark>BambooPure is made entirely from sustainably sourced bamboo and features plant-based bristles, ensuring both durability and environmental responsibility</mark>.
        In addition, for every pack of BambooPure toothbrushes purchased, our company donates a portion of the proceeds to ocean cleanup initiatives. If you'd like to <mark>learn more or read reviews from our satisfied customers, visit www.bamboopure.com today</mark>!`,
        translation: `에코리빙 이노베이션에서는 지속 가능성이 일상생활의 작은 변화에서 시작된다고 믿습니다. 그래서 저희는 플라스틱 칫솔의 천연 생분해성 대안인 뱀부퓨어 칫솔을 소개하게 되어 기쁩니다.
        기존의 칫솔과 달리, 뱀부퓨어는 지속 가능한 방식으로 공급된 대나무로 만들어졌으며 식물성 칫솔모를 사용하여 내구성과 환경 책임을 모두 보장합니다.
        또한, 뱀부퓨어 칫솔 한 팩이 판매될 때마다 저희 회사는 수익의 일부를 해양 정화 사업에 기부합니다. 더 자세한 정보나 만족한 고객들의 후기를 읽고 싶으시다면, 오늘 www.bamboopure.com을 방문해 주세요!`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us2.mp3",
          uk: "audios/part4/advertisement/uk/uk2.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question:
          "What type of <mark>environmentally friendly</mark> product is being advertised?",
        options: {
          A: "A plant-based <mark>detergent</mark>",
          B: "A reusable <mark>shopping bag</mark>",
          C: "A biodegradable <mark>toothbrush</mark>",
          D: "A solar-powered water <mark>purifier</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 식물성 세제
B: 재사용 가능한 쇼핑백
C: 생분해성 칫솔
D: 태양광 정수기

정답 C: 스크립트의 "introduce the BambooPure Toothbrush—a natural and biodegradable alternative to plastic toothbrushes"에서 광고하는 제품이 생분해성 칫솔임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What makes the product <mark>environmentally friendly</mark>?",
        options: {
          A: "It is made from <mark>recycled plastic</mark>",
          B: "It uses <mark>plant-based</mark> materials",
          C: "It requires <mark>less water</mark> to manufacture",
          D: "It is packaged with <mark>minimal design</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
      A: 재활용 플라스틱으로 만들어졌다
      B: 식물성 재료를 사용한다
      C: 제조 시 물이 덜 필요하다
      D: 최소한의 디자인으로 포장된다
      
      정답 B: 스크립트의 "made entirely from sustainably sourced bamboo and features plant-based bristles"에서 제품이 식물성 재료를 사용한다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "Why should listeners visit the <mark>website</mark>?",
        options: {
          A: "To participate in a <mark>giveaway</mark>",
          B: "To read <mark>customer reviews</mark>",
          C: "To sign up for a <mark>free sample</mark>",
          D: "To subscribe to a <mark>newsletter</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 경품 행사에 참여하기 위해
B: 고객 후기를 읽기 위해
C: 무료 샘플을 신청하기 위해
D: 뉴스레터를 구독하기 위해

정답 B: 스크립트의 "read reviews from our satisfied customers, visit www.bamboopure.com"에서 웹사이트를 방문하면 고객 후기를 읽을 수 있다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk3: {
    type: "advertisement",
    title: "Coffee Subscription Service Advertisement",
    versions: {
      basic: {
        script: `<mark>Our new BrewBox subscription service delivers freshly roasted specialty coffee to your door every month</mark>. Our beans are sourced from Rainforest Alliance certified farms to support sustainable farming practices.
        <mark>Starting May 15, new members can sign up for a free one‑week trial on our website</mark>. 
        <mark>To customize your order or for any inquiries, please reach out to our customer care team today</mark>.`,
        translation: `저희 새 BrewBox 커피 구독 서비스는 매달 신선하게 로스팅된 스페셜티 커피를 귀하의 문앞까지 배달해드립니다. 저희 원두는 지속 가능한 농업을 지원하는 Rainforest Alliance 인증 농장에서 공급됩니다.
        5월 15일부터 신규 회원은 웹사이트에서 일주일 무료 체험을 신청할 수 있습니다.
        주문을 맞춤 설정하거나 문의 사항이 있을 경우, 오늘 바로 고객 지원 팀에 연락해 주십시오.`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us3.mp3",
          uk: "audios/part4/advertisement/uk/uk3.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question:
          'Why does the speaker say "sourced from <mark>Rainforest Alliance certified farms</mark>"?',
        options: {
          A: "To emphasize <mark>ethical sourcing</mark>",
          B: "To detail <mark>roasting techniques</mark>",
          C: "To describe <mark>packaging materials</mark>",
          D: "To promote <mark>brewing methods</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 윤리적 원두 조달을 강조하기 위해
B: 로스팅 기법을 설명하기 위해
C: 포장 재료를 설명하기 위해
D: 추출 방법을 홍보하기 위해

정답 A: 스크립트의 "Our beans are sourced from Rainforest Alliance certified farms to support sustainable farming practices"에서 지속 가능한 농업을 지원하는 윤리적 원두 조달을 강조하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What can new members do starting <mark>May 15</mark>?",
        options: {
          A: "Receive discounted <mark>shipping</mark>",
          B: "Sign up for a <mark>free trial</mark>",
          C: "Purchase <mark>gift cards</mark>",
          D: "Attend a brewing <mark>workshop</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 배송비 할인을 받을 수 있다
B: 무료 체험에 신청할 수 있다
C: 상품권을 구매할 수 있다
D: 커피 추출 워크숍에 참석할 수 있다

정답 B: 스크립트의 "Starting May 15, new members can sign up for a free one‑week trial on our website"에서 5월 15일부터 신규 회원이 무료 체험에 신청할 수 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "Who should customers contact for order <mark>customization</mark>?",
        options: {
          A: "Website <mark>chat bot</mark>",
          B: "Local café <mark>manager</mark>",
          C: "<mark>Customer care</mark> team",
          D: "<mark>Delivery</mark> partner",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 웹사이트 채팅 봇
B: 인근 카페 매니저
C: 고객 지원 팀
D: 배송 파트너

정답 C: 스크립트의 "To customize your order or for any inquiries, please reach out to our customer care team today"에서 주문 맞춤 설정을 위해 고객 지원 팀에 연락해야 한다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk4: {
    type: "advertisement",
    title: "New Service Announcement",
    versions: {
      basic: {
        script: `We are excited to introduce a new feature for our customers at MetroBank! <mark>Starting next month, we will be launching a mobile deposit service</mark>, allowing users to deposit checks using their smartphones—no need to visit a branch!
        Unlike traditional banking, <mark>this feature enables customers to scan and submit checks through our secure mobile app, saving time and effort</mark>.
        To help you get started, <mark>we are offering a free tutorial session</mark> at all MetroBank locations next week. Stop by to learn how to use this convenient new service!`,
        translation: `메트로뱅크의 고객 여러분께 새로운 기능을 소개하게 되어 기쁩니다! 다음 달부터 모바일 입금 서비스를 시작하여, 고객님들이 스마트폰으로 수표를 입금하실 수 있게 됩니다—지점 방문이 필요 없습니다!
        기존의 은행 업무와 달리, 이 기능을 통해 고객님들은 저희의 안전한 모바일 앱으로 수표를 스캔하고 제출하실 수 있어 시간과 노력을 절약하실 수 있습니다.
        시작하시는 데 도움을 드리고자, 다음 주 모든 메트로뱅크 지점에서 무료 튜토리얼 세션을 제공해 드립니다. 이 편리한 새 서비스 사용법을 배우러 들러주세요!`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us4.mp3",
          uk: "audios/part4/advertisement/uk/uk4.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is being introduced?",
        options: {
          A: "A <mark>financial consulting</mark> service",
          B: "A <mark>mobile check deposit</mark> feature",
          C: "A new <mark>rewards program</mark>",
          D: "An updated <mark>branch location</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 재무 상담 서비스
B: 모바일 수표 입금 기능
C: 새로운 리워드 프로그램
D: 업데이트된 지점 위치

정답 B: 스크립트의 "Starting next month, we will be launching a mobile deposit service"에서 모바일 수표 입금 기능이 도입된다는 것을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about the service?",
        options: {
          A: "It <mark>saves time and effort</mark> for customers",
          B: "It requires customers to <mark>visit a branch</mark>",
          C: "It has a <mark>monthly</mark> usage fee",
          D: "It is only for <mark>business accounts</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
      A: 고객의 시간과 노력을 절약해준다
      B: 고객이 지점을 방문해야 한다
      C: 월 사용료가 있다
      D: 기업 계좌만 이용할 수 있다
      
      정답 A: 스크립트의 "this feature enables customers to scan and submit checks through our secure mobile app, saving time and effort"에서 이 서비스가 고객의 시간과 노력을 절약해준다고 명확히 언급하고 있습니다.`,
      },
      {
        id: 3,
        question:
          "Why does the speaker encourage listeners to visit bank branches <mark>next week</mark>?",
        options: {
          A: "Sign up for a <mark>credit card</mark>",
          B: "Attend a <mark>tutorial session</mark>",
          C: "Speak with a <mark>loan</mark> officer",
          D: "Download a <mark>banking report</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 신용카드 신청하기
B: 튜토리얼 세션 참석하기
C: 대출 담당자와 상담하기
D: 은행 보고서 다운로드하기

정답 B: 스크립트의 "we are offering a free tutorial session"에서 무료 튜토리얼 세션에 참석하라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },
  talk5: {
    type: "advertisement",
    title: "Promotional Discount Announcement",
    versions: {
      basic: {
        script: `Attention shoppers! This weekend only, <mark>SmartBuy Electronics is hosting a massive storewide sale</mark>. From Friday through Sunday, all home appliances, laptops, and accessories will be available at discounts of up to 50%.
        For customers looking for an even bigger deal, <mark>those who purchase a SmartBuy-brand laptop will receive a $50 gift card</mark> that can be used for future purchases. This is a great chance to upgrade your devices while saving money!
        Additionally, as in previous sales events, <mark>we will offer free setup assistance for any large appliance purchased during the sale</mark>. Our technicians will be available in-store to help with product setup and answer any questions.
        Don't miss out on these incredible savings! Visit your nearest SmartBuy location this weekend or check our website for a list of stores participating in this promotion.`,
        translation: `쇼핑객 여러분 주목해 주세요! 이번 주말에만, 스마트바이 전자제품 매장에서 대규모 전점 할인 행사를 진행합니다. 금요일부터 일요일까지 모든 가전제품, 노트북, 액세서리를 최대 50% 할인된 가격으로 만나보실 수 있습니다.
        더 큰 혜택을 찾으시는 고객님들을 위해, 스마트바이 브랜드 노트북을 구매하시면 추후 구매 시 사용 가능한 50달러 상당의 기프트 카드를 드립니다. 이는 비용을 절약하면서 기기를 업그레이드할 수 있는 좋은 기회입니다!
        또한, 이전 할인 행사와 마찬가지로, 할인 기간 동안 대형 가전제품을 구매하시면 무료 설치 지원을 제공해 드립니다. 저희 기술자들이 매장에서 제품 설치를 도와드리고 질문에 답변해 드릴 것입니다.
        이 놀라운 절약의 기회를 놓치지 마세요! 이번 주말에 가까운 스마트바이 매장을 방문하시거나 웹사이트에서 이 프로모션에 참여하는 매장 목록을 확인해 보세요.`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us5.mp3",
          uk: "audios/part4/advertisement/uk/uk5.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is being advertised?",
        options: {
          A: "A <mark>new loyalty</mark> program",
          B: "A <mark>storewide sale</mark> event",
          C: "A <mark>home delivery</mark> service",
          D: "A <mark>product recall</mark> notice",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 충성도 프로그램
B: 전점 할인 행사
C: 가정 배달 서비스
D: 제품 리콜 공지

정답 B: 스크립트의 "SmartBuy Electronics is hosting a massive storewide sale"에서 전점 할인 행사를 광고하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "How can customers receive a <mark>gift card</mark>?",
        options: {
          A: "By <mark>purchasing</mark> a specific product",
          B: "By <mark>referring</mark> a friend",
          C: "By registering <mark>online</mark>",
          D: "By completing a <mark>survey</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 특정 제품을 구매함으로써
B: 친구를 추천함으로써
C: 온라인 등록을 통해
D: 설문조사를 완료함으로써

정답 A: 스크립트의 "those who purchase a SmartBuy-brand laptop will receive a $50 gift card"에서 특정 제품(스마트바이 브랜드 노트북)을 구매하면 기프트 카드를 받을 수 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What additional service will be available <mark>during the event</mark>?",
        options: {
          A: "<mark>Free setup</mark> assistance",
          B: "<mark>Free</mark> furniture <mark>delivery</mark>",
          C: "A product <mark>assembly tutorial</mark>",
          D: "A limited <mark>warranty extension</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 무료 설치 지원
B: 무료 가구 배송
C: 제품 조립 튜토리얼
D: 제한적 보증 연장

정답 A: 스크립트의 "we will offer free setup assistance for any large appliance purchased during the sale"에서 할인 행사 기간 동안 무료 설치 지원이 제공된다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk6: {
    type: "advertisement",
    title: "Furniture Sale Promotion Announcement",
    versions: {
      basic: {
        script: `Attention homeowners! For one week only, <mark>Grand Home Furnishings is hosting its annual Summer Savings Event</mark>. From Monday through Sunday, all furniture items, including sofas, dining sets, and bedroom furniture will be available at discounts of up to 40%.
        For those looking to save even more, <mark>customers who spend over $500 will receive a $75 gift card</mark> that can be used for future purchases. This is a great chance to refresh your home while getting extra value for your money!
        Additionally, just like in previous events, <mark>we are offering free delivery on all purchases over $1,000</mark>. Our team will ensure your furniture is safely delivered and set up in your home.
        Don't miss out on this limited-time opportunity! Visit your nearest Grand Home Furnishings store this week or check our website for store locations and additional details.`,
        translation: `주택 소유자 여러분 주목해 주세요! 일주일 동안만, 그랜드 홈 퍼니싱스에서 연례 여름 세일 행사를 진행합니다. 월요일부터 일요일까지 소파, 식탁 세트, 침실 가구를 포함한 모든 가구 품목을 최대 40% 할인된 가격으로 만나보실 수 있습니다.
        더 많은 절약을 원하시는 분들을 위해, 500달러 이상 구매하시는 고객님께는 추후 구매 시 사용 가능한 75달러 상당의 기프트 카드를 드립니다. 이는 여러분의 집을 새롭게 꾸미면서 추가 혜택도 받을 수 있는 좋은 기회입니다!
        또한, 이전 행사와 마찬가지로, 1,000달러 이상 구매하시면 무료 배송 서비스를 제공해 드립니다. 저희 팀이 가구를 안전하게 배송하고 설치해 드릴 것입니다.
        이 한정된 기회를 놓치지 마세요! 이번 주에 가까운 그랜드 홈 퍼니싱스 매장을 방문하시거나 웹사이트에서 매장 위치와 추가 정보를 확인해 보세요.`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us6.mp3",
          uk: "audios/part4/advertisement/uk/uk6.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is being advertised?",
        options: {
          A: "A <mark>furniture</mark> sale",
          B: "A <mark>home renovation</mark> service",
          C: "A <mark>holiday decoration</mark> event",
          D: "A <mark>new product</mark> launch",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 가구 할인 행사
B: 주택 개조 서비스
C: 휴일 장식 행사
D: 신제품 출시

정답 A: 스크립트의 "Grand Home Furnishings is hosting its annual Summer Savings Event"에서 가구 할인 행사를 광고하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "How can customers receive a <mark>gift card</mark>?",
        options: {
          A: "By purchasing a <mark>specific</mark> <mark>item</mark>",
          B: "By spending over a <mark>certain</mark> <mark>amount</mark>",
          C: "By signing up for a <mark>membership</mark>",
          D: "By referring a <mark>friend</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 특정 상품을 구매함으로써
B: 일정 금액 이상을 지출함으로써
C: 멤버십에 가입함으로써
D: 친구를 추천함으로써

정답 B: 스크립트의 "customers who spend over $500 will receive a $75 gift card"에서 500달러 이상 구매 시 기프트 카드를 받을 수 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What <mark>additional service</mark> is being offered?",
        options: {
          A: "<mark>Free</mark> interior design <mark>consultation</mark>",
          B: "<mark>Free</mark> furniture <mark>delivery</mark>",
          C: "A product <mark>assembly tutorial</mark>",
          D: "A limited <mark>warranty extension</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 무료 인테리어 디자인 상담
B: 무료 가구 배송
C: 제품 조립 튜토리얼
D: 제한적 보증 연장

정답 B: 스크립트의 "we are offering free delivery on all purchases over $1,000"에서 무료 가구 배송 서비스가 제공된다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk7: {
    type: "advertisement",
    title: "Photography Workshop Advertisement",
    versions: {
      basic: {
        script: `Have you ever wanted to take professional-quality photos but didn't know where to start? <mark>Sunset Photography Academy is now offering a weekend workshop for beginners</mark>! Our expert instructors will teach you how to adjust camera settings, work with lighting, and compose stunning images.
        From July to September, renowned photographer <mark>Alex Chen</mark> will be leading special masterclasses. <mark>He has captured images for top travel magazines</mark> and will share his insights on outdoor and portrait photography.
        <mark>Visit our Sunset Photography Academy website to view student galleries</mark> and sign up for an introductory session. Spaces are limited, so reserve your spot today!`,
        translation: `전문가 수준의 사진을 찍고 싶었지만 어디서부터 시작해야 할지 몰랐나요? 선셋 포토그래피 아카데미에서 초보자를 위한 주말 워크숍을 제공합니다! 저희의 전문 강사진이 카메라 설정 조정법, 조명 활용법, 멋진 이미지 구도 잡는 법을 가르쳐드립니다.
        7월부터 9월까지, 유명 사진작가 알렉스 첸이 특별 마스터클래스를 진행할 예정입니다. 그는 최고의 여행 잡지들을 위해 사진을 촬영해왔으며, 야외 사진과 인물 사진에 대한 그의 통찰력을 공유할 것입니다.
        선셋 포토그래피 아카데미 웹사이트를 방문하셔서 학생들의 갤러리를 보시고 입문 세션을 신청하세요. 자리가 한정되어 있으니, 오늘 바로 예약하세요!`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us7.mp3",
          uk: "audios/part4/advertisement/uk/uk7.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What type of workshop is being advertised?",
        options: {
          A: "<mark>Graphic design</mark>",
          B: "<mark>Photography</mark>",
          C: "<mark>Painting</mark>",
          D: "<mark>Video editing</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 그래픽 디자인
  B: 사진 촬영
  C: 회화
  D: 비디오 편집
  
  정답 B: 스크립트의 "Sunset Photography Academy is now offering a weekend workshop for beginners"에서 사진 촬영 워크숍을 광고하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker say about <mark>Alex Chen</mark>?",
        options: {
          A: "He has published a book on <mark>photography</mark>",
          B: "He has worked for <mark>travel magazines</mark>",
          C: "He owns a <mark>photography studio</mark>",
          D: "He has won international <mark>awards</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 그가 사진에 관한 책을 출판했다
  B: 그가 여행 잡지를 위해 일했다
  C: 그가 사진 스튜디오를 소유하고 있다
  D: 그가 국제 상을 수상했다
  
  정답 B: 스크립트의 "He has captured images for top travel magazines"에서 알렉스 첸이 여행 잡지를 위해 사진을 촬영했다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "According to the speaker, why should the listeners go to a <mark>website</mark>?",
        options: {
          A: "To view <mark>student galleries</mark>",
          B: "To download a course <mark>brochure</mark>",
          C: "To apply for a <mark>scholarship</mark>",
          D: "To check the <mark>refund policy</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 학생들의 갤러리를 보기 위해
  B: 강좌 브로셔를 다운로드하기 위해
  C: 장학금을 신청하기 위해
  D: 환불 정책을 확인하기 위해
  
  정답 A: 스크립트의 "Visit our Sunset Photography Academy website to view student galleries"에서 웹사이트에서 학생들의 갤러리를 볼 수 있다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk8: {
    type: "advertisement",
    title: "Cooking Class Advertisement",
    versions: {
      basic: {
        script: `Have you ever wanted to improve your cooking skills and prepare restaurant-quality meals at home? <mark>Bella's Culinary Studio will offer a six-week Italian cooking course</mark> for all skill levels. Participants will learn how to make fresh pasta, traditional sauces, and gourmet desserts under the guidance of experienced chefs.
        <mark>For the first time, we are introducing a plant-based cooking segment</mark>, where students can explore delicious vegetarian and vegan Italian dishes.
        <mark>At the end of the course</mark>, students will receive a certificate of completion and <mark>have the opportunity to showcase their dishes at a special tasting event</mark>.
        Visit our website to see class schedules and sign up today!`,
        translation: `요리 실력을 향상시키고 집에서 레스토랑 수준의 요리를 만들고 싶으셨나요? 벨라스 컬리너리 스튜디오에서 모든 수준의 수강생을 위한 6주 과정의 이탈리안 요리 강좌를 제공합니다. 참가자들은 경험 많은 셰프들의 지도 아래 신선한 파스타, 전통 소스, 고급 디저트 만드는 법을 배우게 됩니다.
        이번에 처음으로 채식 요리 코너를 도입하여, 학생들이 맛있는 베지테리안과 비건 이탈리안 요리를 탐구할 수 있습니다.
        과정이 끝나면 수료증을 받고 특별 시식회에서 자신의 요리를 선보일 기회를 갖게 됩니다.
        웹사이트에서 수업 일정을 확인하시고 오늘 등록하세요!`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us8.mp3",
          uk: "audios/part4/advertisement/uk/uk8.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is being advertised?",
        options: {
          A: "A <mark>nutrition seminar</mark>",
          B: "A <mark>bakery</mark> opening",
          C: "A <mark>cooking class</mark>",
          D: "A <mark>food delivery</mark> service",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 영양 세미나
B: 베이커리 오픈
C: 요리 교실
D: 음식 배달 서비스

정답 C: 스크립트의 "Bella's Culinary Studio will offer a six-week Italian cooking course"에서 요리 교실을 광고하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about the course?",
        options: {
          A: "It is <mark>free</mark> for new students",
          B: "It includes <mark>international cuisine</mark>",
          C: "It introduces a <mark>plant-based cooking</mark> segment",
          D: "It provides <mark>one-on-one</mark> chef training",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 신규 학생에게 무료이다
B: 국제 요리가 포함되어 있다
C: 채식 요리 코너가 도입된다
D: 일대일 셰프 트레이닝을 제공한다

정답 C: 스크립트의 "For the first time, we are introducing a plant-based cooking segment"에서 채식 요리 코너가 도입된다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will happen at the <mark>end of the course</mark>?",
        options: {
          A: "A <mark>restaurant</mark> will open",
          B: "Students will take a <mark>final exam</mark>",
          C: "Students will compete for a <mark>scholarship</mark>",
          D: "A <mark>tasting event</mark> will be held",
        },
        correctAnswer: "D",
        explanation: `[선택지 해석]
      A: 레스토랑이 오픈할 것이다
      B: 학생들이 최종 시험을 볼 것이다
      C: 학생들이 장학금을 위해 경쟁할 것이다
      D: 시식회가 열릴 것이다
      
      정답 D: 스크립트의 "have the opportunity to showcase their dishes at a special tasting event"에서 과정 마지막에 시식회가 열린다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk9: {
    type: "advertisement",
    title: "Barista Training Advertisement",
    versions: {
      basic: {
        script: `Would you like to learn the art of making the perfect cup of coffee? <mark>Aroma Barista Academy will offer an intensive four-week training course</mark> designed for coffee enthusiasts and aspiring baristas. Participants will gain hands-on experience in espresso extraction, milk frothing, and latte art techniques.
        <mark>For the first time, we are introducing a specialty coffee tasting session</mark>, where students can explore different brewing methods and compare flavors from around the world.
        At the end of the program, <mark>students will take a final assessment and receive an official certification recognized by the National Barista Association</mark>.
        Visit our website to view the full course schedule and register today!`,
        translation: `완벽한 커피를 만드는 기술을 배우고 싶으신가요? 아로마 바리스타 아카데미에서 커피 애호가와 예비 바리스타를 위한 4주 집중 교육 과정을 제공합니다. 참가자들은 에스프레소 추출, 우유 거품 내기, 라떼 아트 기법에 대한 실습 경험을 쌓게 됩니다.
        이번에 처음으로 스페셜티 커피 테이스팅 세션을 도입하여, 학생들이 다양한 추출 방법을 탐구하고 전 세계의 풍미를 비교할 수 있습니다.
        프로그램이 끝나면 학생들은 최종 평가를 받고 국립 바리스타 협회가 인정하는 공식 인증서를 받게 됩니다.
        웹사이트에서 전체 강좌 일정을 확인하시고 오늘 등록하세요!`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us9.mp3",
          uk: "audios/part4/advertisement/uk/uk9.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is being advertised?",
        options: {
          A: "A new <mark>coffee shop</mark>",
          B: "A <mark>barista training</mark> program",
          C: "A <mark>professional baking</mark> course",
          D: "A <mark>restaurant management</mark> seminar",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 커피숍
B: 바리스타 교육 프로그램
C: 전문 제빵 과정
D: 레스토랑 경영 세미나

정답 B: 스크립트의 "Aroma Barista Academy will offer an intensive four-week training course"에서 바리스타 교육 프로그램을 광고하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about the course?",
        options: {
          A: "It is <mark>free</mark> for <mark>beginners</mark>",
          B: "It includes <mark>business training</mark>",
          C: "It features a <mark>specialty coffee tasting</mark> session",
          D: "It guarantees <mark>job placement</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 초보자에게 무료이다
B: 비즈니스 교육이 포함되어 있다
C: 스페셜티 커피 테이스팅 세션이 특징이다
D: 취업을 보장한다

정답 C: 스크립트의 "For the first time, we are introducing a specialty coffee tasting session"에서 스페셜티 커피 테이스팅 세션이 도입된다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will happen at the <mark>end of the program</mark>?",
        options: {
          A: "Students will open <mark>their own café</mark>",
          B: "Students will receive an official <mark>certification</mark>",
          C: "Participants will compete in a <mark>barista competition</mark>",
          D: "A public <mark>coffee tasting event</mark> will be held",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 학생들이 자신의 카페를 열 것이다
B: 학생들이 공식 인증서를 받을 것이다
C: 참가자들이 바리스타 대회에 참가할 것이다
D: 공개 커피 시음회가 열릴 것이다

정답 B: 스크립트의 "students will take a final assessment and receive an official certification recognized by the National Barista Association"에서 학생들이 공식 인증서를 받게 된다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk10: {
    type: "advertisement",
    title: "Sports Store Promotional Event Advertisement",
    versions: {
      basic: {
        script: `At SpeedPro Sports, we are excited to announce our biggest sale of the year! For one week only, <mark>all athletic gear, including running shoes, workout apparel, and sports equipment, will be available at discounts</mark> of up to 50%.
        In addition to great savings, <mark>we are holding a raffle where one lucky customer will win a free pair of high-performance running shoes</mark>.
        <mark>To enter the raffle, simply make a purchase of $75 or more</mark> in-store or online. Don't miss out on this opportunity to upgrade your sports gear at an unbeatable price. Visit SpeedPro Sports this week and save big!`,
        translation: `스피드프로 스포츠에서 올해 최대 규모의 할인 행사를 알려드리게 되어 기쁩니다! 일주일 동안만, 러닝화, 운동복, 스포츠 장비를 포함한 모든 운동용품을 최대 50% 할인된 가격으로 만나보실 수 있습니다.
        더 큰 혜택을 찾으시는 고객님들을 위해, 스마트바이 브랜드 러닝화를 구매하시면 추후 구매 시 사용 가능한 50달러 상당의 기프트 카드를 드립니다. 이는 비용을 절약하면서 러닝화를 업그레이드할 수 있는 좋은 기회입니다!
        또한, 이전 할인 행사와 마찬가지로, 할인 기간 동안 러닝화를 구매하시면 무료 설치 지원을 제공해 드립니다. 저희 기술자들이 매장에서 러닝화를 설치해 드릴 것입니다.
        이 놀라운 절약의 기회를 놓치지 마세요! 이번 주말에 가까운 스마트바이 매장을 방문하시거나 웹사이트에서 이 프로모션에 참여하는 매장 목록을 확인해 보세요.`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us10.mp3",
          uk: "audios/part4/advertisement/uk/uk10.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What type of business is being advertised?",
        options: {
          A: "A <mark>shoe repair</mark> service",
          B: "A <mark>sporting</mark> goods store",
          C: "A <mark>fitness center</mark>",
          D: "A <mark>bicycle rental</mark> shop",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 신발 수선 서비스
B: 스포츠 용품점
C: 피트니스 센터
D: 자전거 대여점

정답 B: 스크립트의 "all athletic gear, including running shoes, workout apparel, and sports equipment, will be available at discounts"에서 스포츠 용품점임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "According to the speaker, what happens during the event?",
        options: {
          A: "A <mark>free fitness class</mark> is offered",
          B: "A <mark>special guest</mark> will give a <mark>speech</mark>",
          C: "A <mark>raffle</mark> will take place",
          D: "A <mark>new store</mark> location will open",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 무료 피트니스 수업이 제공된다
B: 특별 게스트가 연설을 할 것이다
C: 추첨 이벤트가 진행될 것이다
D: 새로운 매장이 오픈할 것이다

정답 C: 스크립트의 "we are holding a raffle where one lucky customer will win a free pair of high-performance running shoes"에서 추첨 이벤트가 진행된다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "How can the listeners <mark>take part in the raffle</mark>?",
        options: {
          A: "By signing up for a <mark>loyalty program</mark>",
          B: "By <mark>spending a certain amount</mark>",
          C: "By downloading a <mark>mobile app</mark>",
          D: "By attending a product <mark>demonstration</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 멤버십 프로그램에 가입함으로써
B: 일정 금액을 지출함으로써
C: 모바일 앱을 다운로드함으로써
D: 제품 시연회에 참석함으로써

정답 B: 스크립트의 "To enter the raffle, simply make a purchase of $75 or more"에서 75달러 이상 구매하면 추첨 이벤트에 참여할 수 있다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk11: {
    type: "advertisement",
    title: "FitPlus App Advertisement",
    versions: {
      basic: {
        script: `Our FitPlus App provides personalized workout plans and diet tracking in one platform. It uses <mark>AI‑driven fitness coaches</mark> to adapt your routine in real time. <mark>From July 1, users can access a free 14‑day premium trial</mark> through our mobile app. <mark>To upgrade or for support, please contact our helpdesk</mark> today.`,
        translation: `FitPlus 앱은 개인 맞춤 운동 프로그램과 식단 관리를 하나의 플랫폼에서 제공합니다. AI 기반 피트니스 코치 기능으로 실시간으로 루틴을 조정합니다. 7월 1일부터 모바일 앱을 통해 14일간 프리미엄 무료 체험을 이용하실 수 있습니다. 업그레이드나 문의 사항이 있으시면 오늘 바로 헬프데스크에 연락해 주십시오.`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us11.mp3",
          uk: "audios/part4/advertisement/uk/uk11.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question:
          'Why does the speaker say "<mark>AI‑driven fitness coaches</mark>"?',
        options: {
          A: "To highlight <mark>technological innovation</mark>",
          B: "To credit <mark>software developers</mark>",
          C: "To explain <mark>subscription tiers</mark>",
          D: "To clarify <mark>payment methods</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 기술 혁신을 강조하기 위해
B: 소프트웨어 개발자를 언급하기 위해
C: 구독 등급을 설명하기 위해
D: 결제 방식을 명확히 하기 위해

정답 A: 스크립트에서 "AI‑driven fitness coaches"라고 언급한 것은 앱의 기술적 혁신을 강조하기 위한 것입니다.`,
      },
      {
        id: 2,
        question: "What can users do starting <mark>July 1</mark>?",
        options: {
          A: "Earn <mark>reward points</mark>",
          B: "Book <mark>one‑on‑one training</mark>",
          C: "Access a <mark>free trial</mark>",
          D: "Download <mark>meal plans</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 리워드 포인트를 적립할 수 있다
B: 일대일 트레이닝을 예약할 수 있다
C: 무료 체험을 이용할 수 있다
D: 식단표를 다운로드할 수 있다

정답 C: 스크립트의 "From July 1, users can access a free 14‑day premium trial"에서 7월 1일부터 무료 체험을 이용할 수 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "Who should you contact for <mark>support or upgrade</mark>?",
        options: {
          A: "Mobile app <mark>chatbot</mark>",
          B: "Local gym <mark>manager</mark>",
          C: "<mark>Helpdesk</mark>",
          D: "Fitness community <mark>forum</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 모바일 앱 챗봇
B: 인근 체육관 매니저
C: 헬프데스크
D: 피트니스 커뮤니티 포럼

정답 C: 스크립트의 "To upgrade or for support, please contact our helpdesk"에서 업그레이드나 지원을 위해 헬프데스크에 연락해야 한다는 것을 알 수 있습니다.`,
      },
    ],
  },
  talk12: {
    type: "advertisement",
    title: "WorkHive Coworking Advertisement",
    versions: {
      basic: {
        script: `Our new WorkHive coworking membership grants <mark>24/7 access to stylish, fully equipped workspaces in major cities worldwide</mark>. Members benefit from ultrafast fiber‑optic internet, adjustable ergonomic workstations, and unlimited complimentary coffee and tea. <mark>Beginning August 10, members can invite a guest to work alongside them for one full day each month</mark> at no extra charge. Additionally, WorkHive offers weekly networking receptions, monthly workshops led by industry experts, and online resources. To learn more about our membership plans or to start your free trial, visit our website today. <mark>For support or inquiries, please contact us via email or our website</mark>. Join WorkHive now and transform the way you work with a professional community at your fingertips.`,
        translation: `저희 새로운 WorkHive 코워킹 멤버십은 주요 도시 전역에서 스타일리시하고 완비된 업무 공간을 24시간 이용할 수 있는 권한을 드립니다. 멤버는 초고속 광섬유 인터넷, 조절 가능한 인체공학적 워크스테이션, 무제한 무료 커피와 차를 이용할 수 있습니다. 8월 10일부터는 매달 하루 동안 게스트를 무료로 초청할 수 있습니다. 또한 WorkHive는 주간 네트워킹 리셉션, 업계 전문가가 진행하는 월간 워크숍, 온라인 자료를 제공합니다. 멤버십 플랜을 알아보거나 무료 체험을 시작하려면 오늘 웹사이트를 방문하세요. 지원이나 문의는 이메일 또는 웹사이트를 통해 해주십시오. 지금 WorkHive에 가입하시고 전문 커뮤니티와 함께 업무 방식을 혁신하세요.`,
        audioUrl: {
          us: "audios/part4/advertisement/us/us12.mp3",
          uk: "audios/part4/advertisement/uk/uk12.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question:
          'Why does the speaker say "<mark>24/7 access to stylish, fully equipped workspaces in major cities worldwide</mark>"?',
        options: {
          A: "To highlight <mark>global availability</mark>",
          B: "To explain <mark>membership fees</mark>",
          C: "To describe <mark>decor features</mark>",
          D: "To encourage <mark>professional etiquette</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 전 세계 제공 가능성을 강조하기 위해
B: 멤버십 요금을 설명하기 위해
C: 장식 특징을 묘사하기 위해
D: 전문적 예절을 장려하기 위해

정답 A: 스크립트에서 "24/7 access to stylish, fully equipped workspaces in major cities worldwide"라고 언급한 것은 WorkHive의 전 세계적인 이용 가능성을 강조하기 위한 것입니다.`,
      },
      {
        id: 2,
        question:
          "What benefit can members enjoy starting <mark>August 10</mark>?",
        options: {
          A: "A <mark>discount</mark> on monthly fees",
          B: "One <mark>free guest day</mark> per month",
          C: "Priority <mark>booking</mark> for private offices",
          D: "Complimentary <mark>event passes</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 월 사용료 할인
B: 매월 하루 무료 게스트 이용
C: 개인실 우선 예약
D: 무료 이벤트 이용권

정답 B: 스크립트의 "Beginning August 10, members can invite a guest to work alongside them for one full day each month"에서 8월 10일부터 매월 하루 동안 게스트를 무료로 초대할 수 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "How can customers request <mark>support or inquiries</mark>?",
        options: {
          A: "By <mark>phone</mark> only",
          B: "By <mark>email or website</mark>",
          C: "Through the mobile app <mark>chatbot</mark>",
          D: "At a <mark>local office</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 전화로만
B: 이메일 또는 웹사이트를 통해
C: 모바일 앱 챗봇으로
D: 현지 사무실에서

정답 B: 스크립트의 "For support or inquiries, please contact us via email or our website"에서 지원이나 문의는 이메일이나 웹사이트를 통해 할 수 있다는 것을 알 수 있습니다.`,
      },
    ],
  },
};
